import get from 'lodash/get';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useGetClaimsQuery} from '../../redux/services/claimApi';

import AppDashboard from '../AppDashboard';
import ListClaimsScreen from "../../components/claims/ListClaimsScreen";

const parseSearchParams = searchParams => {
  const allowedFields = [
    'status',
    // 'billing_category',
    'patient_id',
    'provider_id',
    'unpaid',
  ];
  const filters = allowedFields.reduce((acc, k) => {
    const val = searchParams.get(k);
    // include_nonowned_sessions should only be set if patient_id is also set
    if (val) {
      if (val === 'true') return {...acc, [k]: true};
      if (val === 'false') return {...acc, [k]: false};
      return {...acc, [k]: val};
    }
    return acc;
  }, {sort: '-date_created'});
  return filters;
};

const handleFilter = ({setFilters, setSearchParams}) => filter => {
  setSearchParams(filter || {});
  setFilters(filter || {});
};

const ListClaimsPage = props => {
  // https://stackoverflow.com/questions/75522048/react-how-to-access-urls-parameters
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(parseSearchParams(searchParams));
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const providerQuery = useGetCurrentProviderQuery();
  const query = useGetClaimsQuery(
    {skip: pageIndex * pageSize || 0, limit: pageSize, ...filters}, 
    {skip: false}
  );
  const childProps = {
    ...props,
    // data
    claims: query?.data?.data || [],
    count: query?.data?.count || 0,
    isLoading: providerQuery?.isLoading || query?.isLoading,
    isUpdating: providerQuery?.isLoading || query?.isFetching || query?.isLoading,
    // pagination
    pageIndex,
    pageSize,
    filters,
    // handlers
    onFilterChange: handleFilter({setFilters, setSearchParams}),
    onPageChange: (e,num) => setPageIndex(num),
    onRowsPerPageChange: e => setPageSize(parseInt(e.target.value, 10)),
  };
  return (
    <AppDashboard title='Claims' loading={childProps.isLoading} showTitle showHomeBtn>
      <ListClaimsScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListClaimsPage;
